<template>
  <div id="contactForm">
    <form @submit.prevent="sendContacting">
      <b-field
        label="שם"
        :type="{ 'is-danger': !isfullNameValid && fullName !== '', 'is-success': isfullNameValid }"
        :message="{ 'השם אינו תקין': !isfullNameValid && fullName !== '' }"
      >
        <b-input
          name="fullName"
          v-model="fullName"
          type="text"
          required
          placeholder="שם"
          icon-pack="fas"
          icon-right="user"
          maxlength="30"
          class="short-input"
        />
      </b-field>

      <b-field
        label="אימייל"
        :type="{ 'is-danger': !isEmailValid && email !== '', 'is-success': isEmailValid }"
        :message="{ 'האימייל אינו תקין': !isEmailValid && email !== '' }"
        class="field-spacer"
      >
        <b-input
          name="email"
          v-model="email"
          type="email"
          required
          placeholder="אימייל"
          icon-pack="fas"
          icon-right="envelope"
          maxlength="40"
          class="short-input"
        />
      </b-field>

      <b-field
        label="טלפון"
        :type="{'is-danger': !isPhoneNumberValid && phoneNumber !== '', 'is-success': isPhoneNumberValid }"
        :message="{ 'מספר הטלפון אינו תקין': !isPhoneNumberValid && phoneNumber !== '' }"
        class="field-spacer"
      >
        <b-input
          name="phoneNumber"
          v-model="phoneNumber"
          type="text"
          required
          placeholder="טלפון"
          icon-pack="fas"
          icon-right="phone"
          maxlength="14"
          class="short-input non-hebrew"
        />
      </b-field>

      <b-field
        label="פנייה"
        :message="{ 'הפנייה חייבת להכיל מעל 10 תווים': !isMessageValid && message !== '' }"
        class="field-spacer"
      >
        <b-input
          name="message"
          v-model="message"
          type="textarea"
          placeholder="תוכן הפנייה"
          maxlength="300"
          class="wide-input"
        />
      </b-field>

      <b-field>
        <p class="control" id="send-button">
          <button type="submit" class="button is-info">שלח פנייה</button>
        </p>
      </b-field>
    </form>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "contactForm",
  data() {
    return {
      fullName: "",
      isfullNameValid: false,
      email: "",
      isEmailValid: false,
      phoneNumber: "",
      isPhoneNumberValid: false,
      message: "",
      isMessageValid: false
    };
  },
  watch: {
    fullName: function() {
      const fullNameRegex =
        "^[a-zA-Z\u0590-\u05fe]+(([',. -][a-zA-Z \u0590-\u05fe])?[a-zA-Z\u0590-\u05fe]*)*[ ]*$";

      this.isfullNameValid =
        this.fullName.match(fullNameRegex) && this.fullName.length >= 2;
    },
    email: function() {
      const emailRegex =
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$";

      this.isEmailValid =
        this.email.match(emailRegex) && this.email.length >= 8;
    },
    phoneNumber: function() {
      const phoneNumberRegex = "^[ +]?[0-9]{1,4}[-]?[0-9]{1,4}[-]?[0-9]{3,4}$";

      this.isPhoneNumberValid =
        this.phoneNumber.match(phoneNumberRegex) &&
        this.phoneNumber.length >= 8;
    },
    message: function() {
      this.isMessageValid = this.message.length > 10;
    }
  },
  methods: {
    sendContacting(e) {
      if (
        this.isfullNameValid &&
        this.isEmailValid &&
        this.isPhoneNumberValid &&
        this.isMessageValid
      ) {
        emailjs
          .sendForm(
            "gmail",
            "maintemplate",
            e.target,
            "user_bwgsS98QOTGctWoK0Axzf"
          )
          .then(
            () => {
              this.$swal("!הפנייה נשלחה", "", "success");
            },
            () => {
              this.$swal("משהו השתבש... נסה שוב מאוחר יותר", "", "error");
            }
          );
      } else {
        this.$swal(
          "טופס הפנייה אינו תקין",
          "...תקן את השדות השגויים ונסה שוב",
          "error"
        );
      }
    }
  }
};
</script>

<style scoped>
#contactForm {
  direction: rtl;
}
.field-spacer {
  padding-top: 2vh;
}
>>> small.counter {
  max-height: 0.1vh;
}
.short-input {
  width: 66%;
}
.wide-input {
  width: 83%;
}
#send-button {
  text-align: right;
  padding-top: 2.7vh;
  padding-bottom: 1.4vh;
}
</style>
